import React from 'react';
import createThemedComponent from '../../../theming/utils/createThemedComponent';
import { TitleStyles } from './Title.styles';
/**
 * Themeable `h1` title component
 *
 * ```js
 * import { Title } from '@minerva-analytics/pantheon';
 * <Title> Minerva Analytics! </Title>
 * ```
 * **Default Styles**
 *
 * To view the component's styling directly, see [Title.styles.js](https://git.cogolo.net/minerva/pantheon/blob/master/src/components/elements/Title/Title.styles.js)
 *
 */

export var TitleComponent = function TitleComponent() {
  return /*#__PURE__*/React.createElement(TitleStyles, null);
};
var Title = createThemedComponent('Title', TitleStyles);
export default Title;